export default {
	type: 'object',
	properties: {
		recordId: { type: 'string' },
		routeId: { type: 'string' },
	},
	required: ['recordId'],
	additionalProperties: false,
}
